import HomeCard from "./homeCard";
import PopUpFormCollaborate from "../../../popUpForms/popUpFormCollaborate";

const CardPreparationMatters = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="preparation"
      title="Preparation Matters"
      titleColor="var(--orange)"
      image="./images/home/card-preparation-matters.png"
      popUpComponent={<PopUpFormCollaborate />}
      content={[
        {
          type: "header-H5",
          color: "var(--green)",
          text: "Protect your Community from Wildfires",
        },

        {
          type: "paragraph",
          color: "var(--gold)",
          text: "Catastrophic wildfires are impacting more and more communities across the globe affecting lives, homes, water, air, land and wildlife.",
        },
        {
          type: "paragraph",
          color: "var(--gold)",
          text: "Use the Wildfire Scorecard to assess your wildfire risk, boost preparedness, and take steps to prevent wildfires in your community.",
        },
        { type: "button", color: "var(--orange)", text: "Pilot with Us" },
      ]}
    />
  );
};

export default CardPreparationMatters;
